import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {
  Login,
  DoctorList,
  Home,
  LoginVerify,
  Survey,
  Register,
  Profile,
  HistoryPage,
  Payment,
  EditProfile,
  UploadFiles,
  EditPro,
} from '../pages';

import { Header, Footer } from '../layout';
import { WalletPayment } from '../pages/WalletPayment';
import { DoctorOnline } from '../pages/DoctorOnline';
import Onlinevisit from '../pages/Onlinevisit';
import PaymentReceipt from '../pages/PaymentReceipt';
import PaymentDebugFlow from '../pages/PaymentDebugFlow';
import ScrollToTop from '../components/ScrollToTop';
import { Paymentvo } from '../pages/Paymentvo';

export const AppRoutes = () => (
  <Router>
    <ScrollToTop />
    <Routes>
      <Route
        path="/doctorlist"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <DoctorList />
            <Footer className={'mt-auto'} />
          </div>
        }
      />
      <Route
        path="/"
        element={
          <div>
            <Header />
            <Home />
            <Footer />
          </div>
        }
      />
      <Route
        path="/Login"
        element={
          <div
            className={'d-flex flex-column min-vh-100 justify-content-between'}
          >
            <Header />
            <Login />
            <Footer />
          </div>
        }
      />
      <Route
        path="/LoginVerify"
        element={
          <div
            className={'d-flex flex-column min-vh-100 justify-content-between'}
          >
            <Header />
            <LoginVerify />
            <Footer />
          </div>
        }
      />
      <Route
        path="/Survey"
        element={
          <div
            className={'d-flex flex-column min-vh-100 justify-content-between'}
          >
            <Header />
            <Survey />
            <Footer />
          </div>
        }
      />
       <Route
        path="/Onlinevisit"
        element={
          <div
            className={'d-flex flex-column min-vh-100 justify-content-between'}
          >
            <Header />
            <Onlinevisit />
            <Footer />
          </div>
        }
      />
      <Route
        path="/uploadFiles"
        element={
          <div
            className={'d-flex flex-column min-vh-100 justify-content-between'}
          >
            <Header />
            <UploadFiles />
            <Footer />
          </div>
        }
      />

      <Route
        path="/Register"
        element={
          <div
            className={'d-flex flex-column min-vh-100 justify-content-between'}
          >
            <Header />
            <Register />
            <Footer className={'mt-auto'} />
          </div>
        }
      />
      <Route
        path="/profile"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <Profile />
            <Footer className={'mt-auto'} />
          </div>
        }
      />
      <Route
        path="/history"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <HistoryPage />
            <Footer className={'mt-auto'} />
          </div>
        }
      />

      <Route
        path="/payment"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <Payment />
            <Footer className={'mt-auto'} />
          </div>
        }
      />

        <Route
        path="/paymentvo"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <Paymentvo />
            <Footer className={'mt-auto'} />
          </div>
        }
      />

      <Route
        path="/VerifyPayment"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <PaymentDebugFlow />
            <Footer className={'mt-auto'} />
          </div>
        }
      />

      <Route
        path="/editprofile"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <EditProfile />
            <Footer className={'mt-auto'} />
          </div>
        }
      />
      <Route
        path="/walletpayment"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <WalletPayment />
            <Footer className={'mt-auto'} />
          </div>
        }
      />
      <Route
        path="/doctoronline"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <DoctorOnline />
            <Footer className={'mt-auto'} />
          </div>
        }
      />
      <Route
        path="/edirPro"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <EditPro />
            <Footer className={'mt-auto'} />
          </div>
        }
      />
      <Route
        path="/PaymentReceipt"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <PaymentReceipt />
            <Footer className={'mt-auto'} />
          </div>
        }
      />
      <Route
        path="/payment-debug"
        element={
          <div className={'d-flex flex-column min-vh-100'}>
            <Header />
            <PaymentDebugFlow />
            <Footer className={'mt-auto'} />
          </div>
        }
      />
    </Routes>
  </Router>
);

export default PaymentReceipt;
